import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/fullStackData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const FullStackDevelopmentService = () => {
  useMetaTags({
    title: "Full-Stack Development in Warrgyizmorsch | Expert Solutions",
    description:
      "Unlock full-stack development services in Warrgyizmorsch. We build modern, scalable web applications using top front-end and back-end technologies.",
    keywords:
      "Full-Stack Development, full stack web developers, fullstack web development, full stack website development, full stack developer web developer, full web stack development, full stack development services, fullstack development, full stack software developer, full stack software development, full stack development company",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h2 className="sec-title text-white">
                Full-Stack Development That Powers Growth
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        .extra-box{
          display: flex;
          height: 70px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 25px;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/fullstack.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  We provide end-to-end development with full stack development
                  that takes your idea and turns it into large scale high
                  performing digital products. From front end aesthetics to back
                  end power we do it all in house. Our approach is that your
                  product will grow with your business smoothly, secure and
                  efficient. We are not just developers, we are your technology
                  growth partners.
                </p>
              </div>
            </div>
            {/* Key Benefits of Full-Stack Development for Your Projects  */}
            <Handle_Largedata_section LargeData={LargeData} />
            {/* End-to-End Full-Stack Development Services */}
            <Custom_section data={CustomSection} />
            {/* Why Choose the MEAN/MERN Stack?  */}
            <Benefits_section data={BenefitSection} />
            {/* Why Choose Warrgyizmorsch's Full Stack Web Developers?  */}
            <Boost_section data={BoostSection} />
            <div className="extra-box"></div>
            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default FullStackDevelopmentService;
